// removed by extract-text-webpack-plugin
module.exports = {"Burger":"Burger__Burger__-hash--base64-5-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/Burger.css
// module id = 90
// module chunks = 0